import $ from 'jquery';
import LazyLoad from 'vanilla-lazyload';
import YoutubeLazyload from './youtube-lazyload';

window.sliders = {};
window.lazyloadInstance = null;

$(() => {
  // back to previous page, credit : https://stackoverflow.com/a/46163215/1843755
  $('.btn.back-page').on('click', () => {
    history.back();
    return false;
  });

  // lazyload image
  window.lazyloadInstance = new LazyLoad({
    elements_selector: '.lazyload'
  });

  document.body.addEventListener('htmx:load', function(evt) {
    // reload lazyload image on sprig/htmx loaded
    window.lazyloadInstance.update();
  });
  
  // bootstrap carousel
  $('.bs-slider').carousel();
  
  $('#featured-product').owlCarousel({
    loop: true,
    margin: 30,
    center: false,
    nav: false,
    dots: true,
    autoplay: true,
    responsiveClass: true,
    responsive: {
      0: { items: 1, nav: false },
      768: { items: 2 },
      1170: { items: 4 }
    }
  });
  $('#slider-quote').owlCarousel({
    loop: true,
    margin: 30,
    nav: false,
    dots: true,
    autoplay:true,
    autoplayTimeout: window.sliders.quoteSlider ? window.sliders.quoteSlider.interval : 7000,
    responsiveClass: true,
    responsive: {
      0: { items: 1 },
      1650: { items: 1 }
    }
  });
  $('#thumbnail-sliders').owlCarousel({
    loop: true,
    margin: 30,
    nav: false,
    dots: true,
    autoplay:true,
    responsiveClass: true,
    responsive: {
      0: { items: 1 },
      1650: { items: 1 }
    }
  });

  YoutubeLazyload.init('.youtube-player');

  // popup homepage
  const homepagePopupEl = document.querySelector('#homepage-popup');
  if (homepagePopupEl) {
    $('#homepage-popup').modal({
      backdrop: 'static',
      show: true,
    });
  }

  /* homepage 2024 */
  const isHomepage = document.querySelector('main[data-page="home"]') != null;
  const youtubeVideosEl = document.querySelector('#youtube-videos');
  const featuredSliderEl = document.querySelector('#slider-featured');
  const thumbnailGalleryEl = document.querySelector('#animated-thumbnails-gallery');
  if (featuredSliderEl) {
    var items = thumbnailGalleryEl.querySelectorAll('.gallery-item');
    var height = featuredSliderEl.offsetHeight;
    // initially hide the thumnail gallery because it will break the height
    thumbnailGalleryEl.classList.remove('d-none');
    thumbnailGalleryEl.style.height = height+'px';

    window.lightGallery(
      document.getElementById("animated-thumbnails-gallery"),
      {
        autoplayFirstVideo: false,
        pager: false,
        galleryId: "nature",
        thumbnail: true,
        plugins: [lgZoom, lgThumbnail],
        mobileSettings: {
          controls: false,
          showCloseIcon: false,
          download: false,
          rotate: false
        },
        addClass: 'lg-custom-thumbnails',

        // Remove the starting animations.
        // This can be done by overriding CSS as well
        appendThumbnailsTo: '.lg-outer',

      }
    );
  }

  if (document.querySelector('#slider1-desktop')) {
    $('#slider1-desktop').owlCarousel({
      loop: true,
      center: true,
      autoplay: false,
      margin: 20,
      dots: true,
      nav: false,
      items: 1,
      responsiveClass: true,
    });
  }

  if (document.querySelector('#slider1-mobile')) {
    $('#slider1-mobile').owlCarousel({
      loop: true,
      center: true,
      autoplay: false,
      margin: 20,
      dots: true,
      nav: false,
      items: 1,
      responsiveClass: true,
    });
  }

  if (document.querySelector('#slider2')) {
    $('#slider2').owlCarousel({
      loop: true,
      center: true,
      autoplay: false,
      margin: 20,
      dots: true,
      nav: false,
      items: 3,
      responsiveClass: true,
    });
  }

  function countStart() {
    var countupEls = document.querySelectorAll("[data-countup]");
    countupEls.forEach(function (el) {
      let demo = new countUp.CountUp(el, el.dataset.countup, {
        useEasing: true,
        useGrouping: true,
        separator: ",",
        decimal: "."
      });
      if (!demo.error) {
        demo.start();
      } else {
        console.error(demo.error);
      }
    });
  }

  if (youtubeVideosEl) {
    new Waypoint({
      element: youtubeVideosEl,
      handler: function() {
        countStart()
        //this.destroy() //for once
      },
      offset: '50%'
    });
  }

  if (isHomepage) {
    // execute function on scroll
    var navbarElement = document.querySelector('.h14-navbar');
    navbarElement.classList.add('bg-transparent');

    window.addEventListener('scroll', () => {
      var scroll = window.pageYOffset;

      if (scroll > 50) {
        navbarElement.classList.remove('bg-transparent');
      } else {
        navbarElement.classList.add('bg-transparent');
      }
    });
  }

  // https://stackoverflow.com/a/30364316/1843755
  if (document.querySelector('#youtube-carousel')) {
    var youtubeSlider = $('#youtube-carousel');
    youtubeSlider.owlCarousel({
      loop: true,
      margin: 25,
      center: true,
      nav: 0,
      dots: 0,
      autoplay: 0,
      responsive:{
        0: {
          items: 1
        },
        600: {
          items: 1
        },
        1000: {
          items: 1
        }
      }
    });

    $('#youtube-videos .prevButton').click(function() {
      youtubeSlider.trigger('prev.owl.carousel');
    });

    $('#youtube-videos .nextButton').click(function() {
      youtubeSlider.trigger('next.owl.carousel');
    });
  }

});

function initializeMegaDropdown() {
  let timeout;
  const dropdowns = document.querySelectorAll('.mega-dropdown');
  
  dropdowns.forEach(dropdown => {
    const menu = dropdown.querySelector('.dropdown-menu');
    
    dropdown.addEventListener('mouseenter', function() {
      clearTimeout(timeout);
      
      dropdowns.forEach(otherDropdown => {
        if (otherDropdown !== dropdown) {
          const otherMenu = otherDropdown.querySelector('.dropdown-menu');
          otherMenu.classList.remove('show');
        }
      });
      
      menu.classList.add('show');
    });
    
    dropdown.addEventListener('mouseleave', function() {
      timeout = setTimeout(() => {
        menu.classList.remove('show');
      }, 100);
    });
  });
}


document.addEventListener('DOMContentLoaded', function() {
  initializeMegaDropdown();
});

document.body.addEventListener('htmx:afterSwap', function(event) {
  initializeMegaDropdown();
});